var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('progress-bar',{staticClass:"judging-progress-bar",attrs:{"value":_vm.picksUsed,"total":_vm.total,"units":_vm.units}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }